export default __webpack_public_path__ + "alberta-dot.c903a1950f7aa3f0f01a.svg";